// extracted by mini-css-extract-plugin
module.exports = {"title":"_ace8032","titleWrapper":"_e5d9cdc","icon":"_78e8ab3","iconOpen":"_db6c0a1"};